import { AiUsagePage } from "@/features/admin/AiUsagePage";
import { useAppShell } from "@/shell/app-shell-context";

export function AiUsageRoute() {
  const { token } = useAppShell();
  return <AiUsagePage token={token} />;
}
